import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export type MissionSpecialistProgramInstanceOverviewInstance = {
  programInstanceId: string
  programInstanceName: string
  displayName: string | null
  msDisplayName: string | null
  programGroupId: string
  programGroupName: string
  liveProgramId: string
  recyclerProgramId: string | null
  recyclerTrainingProgramId: string | null
  iconType: string | null
  color: string | null
  isEligible: boolean
  liveEligible: boolean
  recyclerEligible: boolean
  recyclerTrainingAssigned: boolean
  recyclerTrainingCertified: boolean
  recyclerTrainingProgress: number | null
  hasTaskHistory: boolean
  visibilityReason: 'eligible' | 'training' | 'history'
  unreadCount: number
  unreadCommentsCount: number
  perWeekAvg: number[]
}

export type MissionSpecialistProgramInstanceOverviewGroup = {
  programGroupId: string
  programGroupName: string
  programGroupDisplayName: string | null
  description: string | null
  iconType: string | null
  color: string | null
  totalIncorrectUnread: number
  totalUnreadComments: number
  instances: MissionSpecialistProgramInstanceOverviewInstance[]
}

export type MissionSpecialistProgramInstancesOverviewResponse = {
  userLastLogin: string | null
  groups: MissionSpecialistProgramInstanceOverviewGroup[]
}

export const MSUnifiedOverviewKey = 'unified-overview-of-mission-specialist'

async function queryFn() {
  const response = await apiClient.get<MissionSpecialistProgramInstancesOverviewResponse>(
    '/int/v3/operators/program-instances/overview'
  )

  return response.data
}

export function useUnifiedOverview() {
  return useQuery({
    queryKey: [MSUnifiedOverviewKey],
    queryFn,
    refetchOnWindowFocus: true,
  })
}
